import React from "react";
import * as Type from "@interface/index";

interface PropsInterface {
  children?: React.ReactChild | React.ReactChildren | React.ReactChild[] | React.ReactChildren[];
  clickOutside: () => any;
}

export default class Clickoutside extends React.Component<PropsInterface> {
  private wrapperRef: React.RefObject<HTMLInputElement> = React.createRef();

  public constructor(props: PropsInterface) {
    super(props);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  private handleClickOutside(event: any) {
    if (!this.wrapperRef?.current?.contains(event.target)) {
      this.props.clickOutside();
    }
  }

  public render() {
    return <div ref={this.wrapperRef}>{this.props.children}</div>;
  }
}
